import { render, staticRenderFns } from "./should_charge_v2.vue?vue&type=template&id=b96f02e6&"
import script from "./should_charge_v2.vue?vue&type=script&lang=js&"
export * from "./should_charge_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports